import { getImageFromS3 } from '../imageService';

export const movieGenreStart = {
  title: 'Кіновечірка: обери жанр на вечір',
  description:
    'На носі кіновечірка?\nВсього 5 питань — і жанр підібрано!\nКамера. Мотор.',
  button: 'Починаймо!'
};

export const movieGenreChallengeList = [
  {
    id: '1',
    question: 'Що для тебе важливо у фільмі?',
    answers: [
      { key: 1, value: 'Динамічні сцени' },
      { key: 2, value: 'Затишна атмосфера' },
      { key: 3, value: 'Естетичні кадри' },
      { key: 4, value: 'Яскраві кольори та стиль' }
    ]
  },
  {
    id: '2',
    question: 'Які емоції хочеш отримати від перегляду?',
    answers: [
      { key: 1, value: 'Напруження й адреналін' },
      { key: 2, value: 'Легкість і сміх' },
      { key: 3, value: 'Гармонію та затишок' },
      { key: 4, value: 'Емоційні гойдалки' }
    ]
  },
  {
    id: '3',
    question: 'Який темп фільму тобі ближчий?',
    answers: [
      { key: 1, value: 'Швидкий, без пауз' },
      { key: 2, value: 'Спокійний і розслаблений' },
      { key: 3, value: 'Повільний, але красивий' },
      { key: 4, value: 'Непередбачуваний' }
    ]
  },
  {
    id: '4',
    question: 'Ідеальний вечір — це…',
    answers: [
      { key: 1, value: 'Максимум вражень' },
      { key: 2, value: 'Тепла компанія й плед' },
      { key: 3, value: 'Краса в усьому до деталей' },
      { key: 4, value: 'Менше слів — більше відчуттів' }
    ]
  },
  {
    id: '5',
    question: 'Після фільму хочеться…',
    answers: [
      { key: 1, value: 'Обговорювати сцени й повороти' },
      { key: 2, value: 'Просто усміхатись і радіти' },
      { key: 3, value: 'Помовчати' },
      { key: 4, value: 'Довго думати про сюжет' }
    ]
  }
];

export const movieGenreResultList = [
  {
    id: '1',
    title: 'Твій жанр — екшн / трилер',
    description:
      'Цей вечір — про напругу й драйв. Фільм не відпускатиме ні на хвилину, триматиме увагу й змусить затамувати подих.\nРекомендуємо переглянути ці стрічки.',
    trailerLink:
      'https://youtube.com/playlist?list=PLZ_R2rgMQg3Y&si=T5y_rMHVKSooqR7C',
    image: getImageFromS3('images/movie-genre-challenge/1.png')
  },
  {
    id: '2',
    title: 'Твій жанр — комедія',
    description:
      'Цей вечір — про легкість і сміх. Без складних сюжетів і зайвих роздумів: лише тепла атмосфера, жарти й жива компанія.\nРекомендуємо переглянути ці стрічки.',
    trailerLink:
      'https://youtube.com/playlist?list=PLXxtG6ciKPvk&si=XjkmIyHPNyC7CtjU',
    image: getImageFromS3('images/movie-genre-challenge/2.png')
  },
  {
    id: '3',
    title: 'Твій жанр — драма',
    description:
      'Цей вечір — про затишок і внутрішній баланс. Фільм створить ритм, у якому хочеться загорнутись у плед і побути в моменті.\nРекомендуємо переглянути ці стрічки.',
    trailerLink:
      'https://youtube.com/playlist?list=PLOYFn1lo-HpA&si=ow5yaSS2hKyvKzC0',
    image: getImageFromS3('images/movie-genre-challenge/3.png')
  },
  {
    id: '4',
    title: 'Твій жанр — артхаус',
    description:
      'Цей вечір — про естетику й післясмак. Кадри, музика й паузи працюють разом, створюючи настрій, який хочеться відчувати ще довго після титрів.\nРекомендуємо переглянути ці стрічки.',
    trailerLink:
      'https://youtube.com/playlist?list=PLPhrjLCYJnDY&si=bpj_c65xVAWtqzJM',
    image: getImageFromS3('images/movie-genre-challenge/4.png')
  }
];

export const movieGenreFinish = {
  title: 'Тепер гарний вечір точно гарантовано!',
  description: 'Дякуємо за твою активну участь!',
  image: getImageFromS3('images/movie-genre-challenge/after-result.png')
};
